export const SALESFORCE_ROOT = '//sunrun.my.salesforce.com';
